// DotsLoader.js
import React from "react";
import "./dotsLoader.css";

const DotsLoader = () => {
  return (
    <div className="dots-loader">
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
};

export default DotsLoader;
